
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { usePlanillassStore } from '../../../../store';
import { separadorMillares } from '../../../../helpers';



export const TablaTotalLIstPlanilla = () => {


    const { datosPlanilla } = usePlanillassStore();


    return (
        <Paper sx={{width:'100%', maxWidth:{xs:450, sm:'100%', md:'100%'}, overflowX:'auto', my:2}}>
            <TableContainer >
                <Table sx={{minWidth:700, overflowX:'auto'}}>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{width:'20%'}}>PLANILLAS</TableCell>
                            <TableCell sx={{width:'30%'}}>TOTAL</TableCell>
                            <TableCell sx={{width:'25%'}}>ABONOS</TableCell>
                            <TableCell sx={{width:'25%'}}>SALDO</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {Object.keys(datosPlanilla || {}).length 
                        ?   <TableRow>
                                <TableCell>{datosPlanilla.items}</TableCell>
                                <TableCell>{`$${separadorMillares(datosPlanilla.valor)}`}</TableCell>
                                <TableCell>{`$${separadorMillares(datosPlanilla.valor - datosPlanilla.saldo)}`}</TableCell>
                                <TableCell>{`$${separadorMillares(datosPlanilla.saldo)}`}</TableCell>
                            </TableRow>

                        :   <TableRow>
                                <TableCell colSpan={4} align="center">No hay datos disponibles</TableCell>
                            </TableRow>
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
        
    )
}
